import { useDialog } from 'primevue/usedialog'
import PagesList from '../components/cms/admin/Pages/pagesList.vue'

export function useChoosePage() {
  const dialog = useDialog()
  const choosePage = (): Promise<string> => {
    return new Promise((resolve) => {
      dialog.open(PagesList, {
        props: {
          header: 'Wybierz page',
          style: {
            width: '80vw',
            height: '80vh'
          },
          modal: true
        },
        onClose: (options) => {
          if (!options?.data) return resolve('')
          resolve(options.data.pageURL ?? '')
        }
      })
    })
  }

  return { choosePage }
}
